// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__27mDe","content":"LayoutSettings_content__2O-KE"};